import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

// 🔹 Accept Project (Salesperson)
export const salespersonAcceptAction = createAsyncThunk(
    "salesperson/acceptProject",
    async (
        { projectId, typeservicecost, totaltypeservicecost }, { rejectWithValue  }
    ) => {
        try {
            const res = await axiosInstance.post(
                `${BackendURL}/managerProjectRequested/salesperson-accept`,
                { projectId, typeservicecost, totaltypeservicecost },
               
            );

            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to accept project"
            );
        }
    }
);

const salespersonSlice = createSlice({
    name: "salesperson",
    initialState: {
        loading: false,
        success: false,
        error: null,
        acceptedProject: null,
    },
    reducers: {
        resetSalespersonState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.acceptedProject = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // ✅ Accept Project
            .addCase(salespersonAcceptAction.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(salespersonAcceptAction.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.acceptedProject = action.payload.project;
            })
            .addCase(salespersonAcceptAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            });
    },
});

export const { resetSalespersonState } = salespersonSlice.actions;
export default salespersonSlice.reducer;
